//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterPriorityService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterPriority.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-priority/detail', {'params':params});
	};

	//GeneratorFlag:[LetterPriority.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-priority/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}